import { render, staticRenderFns } from "./MainLogin.vue?vue&type=template&id=02bcf214&scoped=true&"
import script from "./MainLogin.vue?vue&type=script&lang=js&"
export * from "./MainLogin.vue?vue&type=script&lang=js&"
import style0 from "./MainLogin.vue?vue&type=style&index=0&id=02bcf214&lang=scss&scoped=true&"
import style1 from "./MainLogin.vue?vue&type=style&index=1&id=02bcf214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bcf214",
  null
  
)

export default component.exports